import React from "react";

export interface RadioOption {
  value: string;
  label?: string;
}

export interface RadioGroupProps {
  options: RadioOption[]; // Array of options for the radio group
  selectedValue: string; // The currently selected value
  onChange: (value: string) => void; // Callback when a value is selected
  className?: string; // Optional custom class for the container
  buttonClassName?: string; // Optional custom class for the buttons
  selectedButtonClassName?: string; // Optional custom class for the selected button
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  options,
  selectedValue,
  onChange,
  className = "",
  buttonClassName = "",
  selectedButtonClassName = "border border-white/30",
}) => {
  return (
    <div className={`grid grid-cols-1 gap-4 ${className}`}>
      {options.map((item, index) => {
        const isSelected = selectedValue === item.value;
        return (
          <div key={index} className="flex items-start justify-start">
            <button
              onClick={() => onChange(item.value)}
              className={`w-full items-center justify-center bg-white/15 backdrop-blur-md flex flex-row py-4 text-white ${
                isSelected ? selectedButtonClassName : buttonClassName
              }`}
            >
              <span className="text-[12px] md:text-[20px] font-[600] flex-grow">
                {item.label || item.value}
              </span>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default RadioGroup;
